module.exports = __webpack_public_path__ + "img/FixedPositionCta.cf125819.png";